"use client";

import React from "react";
import { Target, Palette, Brush, Fingerprint, TrendingUp, ArrowUpRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const services = [{
  title: "Luxury Estates",
  description: "Premium landscaping and seasonal upkeep for high-end residential communities and private villas.",
  icon: Target,
  colSpan: "lg:col-span-4"
}, {
  title: "Corporate Hubs",
  description: "Full-service interior painting and aesthetic maintenance for modern, high-performance workspaces.",
  icon: Palette,
  colSpan: "lg:col-span-4"
}, {
  title: "Retail Districts",
  description: "Comprehensive janitorial services and exterior power washing for high-traffic commercial centers.",
  icon: Brush,
  colSpan: "lg:col-span-4"
}, {
  title: "Property Managers",
  description: "Dedicated maintenance concierge services providing a one-stop solution for facility care and reliability.",
  icon: Fingerprint,
  colSpan: "lg:col-span-6"
}, {
  title: "Growth Partners",
  description: "Scalable maintenance strategies engineered to preserve long-term property value and curb appeal.",
  icon: TrendingUp,
  colSpan: "lg:col-span-6"
}];
export default function Services() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="services" className="py-24 md:py-32 bg-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
        <div className="absolute top-[-10%] left-[-5%] w-[50%] h-[50%] bg-primary-100 rounded-full blur-[140px]" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[50%] h-[50%] bg-accent-100 rounded-full blur-[140px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mb-20 transition-all duration-1000 cubic-bezier(0.175, 0.885, 0.32, 1.275) ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
          <div className="flex items-center gap-4 mb-6">
            <span className="h-[2px] w-12 bg-primary rounded-full" />
            <span className="text-primary font-bold tracking-widest uppercase text-xs">
              Fluid Professionalism
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground mb-8 leading-[1.1]">
            Comprehensive Facility <br />
            <span className="text-primary">Maintenance Mastery</span>
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
            Elyon Maintenance Inc. is your one-stop shop for property care. We provide 
            seamless solutions that wash away the stress of facility upkeep.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className={`${service.colSpan} group relative border-border/50 bg-card/40 backdrop-blur-xl rounded-[24px] shadow-sm hover:shadow-2xl hover:shadow-primary/10 transition-all duration-500 hover:-translate-y-2 flex flex-col py-0 gap-0 overflow-hidden`}>
              <CardHeader className="p-8 pb-6">
                <div className="mb-8 p-4 rounded-2xl bg-primary-100/50 w-fit group-hover:bg-primary transition-all duration-500 group-hover:scale-110 group-hover:rotate-6">
                  <service.icon className="w-8 h-8 text-primary group-hover:text-white transition-colors duration-500" />
                </div>
                <CardTitle className="text-2xl font-bold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="px-8 pb-8 pt-0 flex-grow flex flex-col">
                <CardDescription className="text-base text-muted-foreground mb-10 leading-relaxed flex-grow">
                  {service.description}
                </CardDescription>
                
                <div className="pt-8 border-t border-border/40">
                  <Link to="/OurServicesPage" className="inline-flex items-center gap-2 text-primary font-bold text-sm uppercase tracking-wider group/link hover:opacity-80 transition-opacity">
                    Explore Service
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1 group-hover/link:-translate-y-1" />
                  </Link>
                </div>
              </CardContent>

              {}
              <div className="absolute -bottom-16 -right-16 w-32 h-32 bg-primary/5 rounded-full blur-3xl group-hover:bg-primary/10 transition-all duration-700" />
            </Card>)}
        </div>
      </div>
    </section>;
}